module.exports = __webpack_public_path__ + "static/logo_white@2x-ab116fc489d91d75b86ab5e6a805cac9.png";